import { render } from "./TodosSearch.vue?vue&type=template&id=351fdf54"
import script from "./TodosSearch.vue?vue&type=script&lang=js"
export * from "./TodosSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__